import { useModal } from "@/common/contexts/Modal.context";
import { Button } from "antd";
import { useNavigate } from "react-router";
import { ListIcon } from "../icon";
import Typography from "../Typography/Typography";

export default function QuoteValidationModal({
  quoteReqData,
}: {
  quoteReqData: any;
}) {
  const { closeModal } = useModal();
  const navigate = useNavigate();
  const onBackClick = () => {
    closeModal();
  };
  const onCreateManual = () => {
    navigate("/singleManualQuote", { state: { quoteReqData } });
  };
  return (
    <div className="max-w-[560px] w-full flex flex-col gap-4">
      <Typography
        mb={8}
        type="p"
        uppercase
        fontFamily="font-kanit"
        fontWeight="font-semibold"
        fontSize={24}
        textAlign="center"
        textColor="black"
      >
        Error during address validation
      </Typography>
      <div className="text-yellow-icon flex items-center justify-center">
        <ListIcon width={53} height={53} />
      </div>
      <Typography mt={6} type="p" fontFamily="font-kanit" textAlign="center">
        We couldn't find any matching vendors in our database. You can either go
        back to the address selection section or create a quote manually
      </Typography>
      <div className="flex items-center justify-center gap-4 mt-6">
        <Button
          onClick={onBackClick}
          type="primary"
          className="h-10 font-inter font-semibold"
        >
          Back
        </Button>
        <Button
          onClick={onCreateManual}
          type="primary"
          className="h-10 font-inter font-semibold"
        >
          Create manual quote
        </Button>
      </div>
    </div>
  );
}
